import { Component } from '@angular/core';

@Component({
    template: `<div class="full-height content-centered">
        <h1 class="headline">Unauthorized Access</h1>
        <p class="headline">Try contacting system administrator</p>
        </div>`
})
export class ErrorComponent {}